module.exports = ".modal-title {\n  display: inline; }\n\n.btn-secondary {\n  color: #000000 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/editusermodal.component.scss
// module id = 590
// module chunks = 1